import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "application-header" };
var _hoisted_2 = { class: "application-header__language-selector" };
import VariableLogo from './VariableLogo.vue';
import { ArrowDownBold } from '@element-plus/icons-vue';
var selectedLanguage = 'Русский';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ApplicationHeader',
    setup: function (__props) {
        var languages = ['Русский', 'English'];
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(VariableLogo, {
                    size: 58,
                    pd: 10,
                    rounded: 14
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(ArrowDownBold))
                ])
            ]));
        };
    }
});
